var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcZahlungsinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0624 13.3181C23.5801 13.3181 23.9999 12.8984 23.9999 12.3806V6.93745C23.9999 4.86971 22.3176 3.18747 20.2499 3.18747H3.74998C1.68224 3.18747 0 4.86971 0 6.93745V17.0624C0 19.1301 1.68224 20.8124 3.74998 20.8124H20.2499C22.3176 20.8124 23.9999 19.1301 23.9999 17.0624C23.9999 16.5446 23.5801 16.1249 23.0624 16.1249C22.5446 16.1249 22.1249 16.5446 22.1249 17.0624C22.1249 18.0963 21.2838 18.9374 20.2499 18.9374H3.74998C2.71611 18.9374 1.87499 18.0963 1.87499 17.0624V10.0369H22.1249V12.3806C22.1249 12.8984 22.5446 13.3181 23.0624 13.3181ZM1.87499 8.16191V6.93745C1.87499 5.90358 2.71611 5.06246 3.74998 5.06246H20.2499C21.2838 5.06246 22.1249 5.90358 22.1249 6.93745V8.16191H1.87499Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23.9999V23.9999H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZahlungsinfo);
export default __webpack_public_path__ + "static/media/ic_zahlungsinfo.1d7c922981ca24963c28d42fd0f344c0.svg";
export { ForwardRef as ReactComponent };